import React from "react";
import Helmet from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "../components/Layout";
import Image from "../components/Image";
import styles from "../styles/page.module.scss";

const About = () => {
  const data = useStaticQuery(graphql`
    query imageQuery {
      fileName: file(relativePath: { eq: "images/dancer-danger.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const srcInfo = (
    <>
    Man Ray, <em>Dancer/Danger (L’impossible)</em>, 1920.
    </>
  );

  const old = [
    {
      authors: "GONÇALVES, Rafael",
      url: "https://doi.org/10.34024/2764859n.3",
      title:
        "Captura como fenômeno sociotécnico: apontamentos para uma caracterização a partir de tecnologias de inteligência artificial",
      complement: "<em>Revista Pimentalab</em>,  v. 3 (Tecnoceno), 30-38, 2025.",
    },
    {
      authors: "GONÇALVES, Rafael; PADOVAN, Giordanno Oliveira",
      url: "https://ocs.ige.unicamp.br/ojs/react/article/view/4035",
      title:
        "Coletivos maquínicos e sistemas digitais: Tensionamentos da noção de humanidade a partir de técnicas de aprendizado de máquina patenteadas pela Google",
      complement: "<em>Anais IX Reunião de Antropologia da Ciência e Tecnologia (ReACT)</em>, v. 6, n. 6, 2024.",
    },
    {
      authors: "GONÇALVES, Rafael",
      url: "http://doi.org/10.34024/2764859n.3",
      title:
        "Captura como fenômeno sociotécnico: apontamentos para uma caracterização a partir de tecnologias de inteligência artificial",
      complement: "<em>Revista Pimentalab</em>, v. 3 (Tecnoceno), p. 30-38, 2024.",
    },
    {
      authors: "GONÇALVES, Rafael; FERREIRA, Pedro P",
      url: "https://reunioes.sbpcnet.org.br/74RA/inscritos/resumos/1392_16e072f0ac3379ec7ebf29ee4ddbced95.pdf",
      title:
        "Aprendizado de máquina como mediação técnica computacional: viés de gênero no processamento automático de textos relacionando pronomes e profissões pelo algoritmo BERT",
      complement:
        "<em>Anais [recurso eletrônico]: resumos da 74ª Reunião Anual da SBPC</em>, 24 jul. 2022.",
    },
    {
      authors: "GONÇALVES, Rafael; FERREIRA, Pedro P",
      url: "https://www.prp.unicamp.br/inscricao-congresso/resumos/2022P20272A33708O343.pdf",
      title:
        "Eficiência como viés algorítmico nas técnicas de aprendizado de máquina: caracterização baseada na produção tecnocientífica da Google",
      complement: "<em>XXX Congresso de Iniciação Científica da Unicamp</em>, 2022.",
    },
  ];

  const productionList = [
    {
      authors: "GONÇALVES, Rafael; Cortez Salviano, Maria",
      url: "https://periodicos.unespar.edu.br/revistacientifica/article/view/11739",
      title:
        "Entre a representação e a performatividade: uma exploração da imagem técnica do Renascimento à Inteligência Artificial",
      complement: "<em>Revista Científica/FAP</em>, v. 34, n. 1, pp. 97-125 , 2026.",
    },
    {
      authors: "GONÇALVES, Rafael",
      url: "https://preprints.scielo.org/index.php/scielo/preprint/view/17723",
      title:
        "Tradução automática, computação digital e memória: uma investigação em diálogo com Gilbert Simondon ",
      complement: "<em>50º Encontro Anual da ANPOCS </em>, Scielo Preprints, 2026.",
    },
    {
      authors: "GONÇALVES, Rafael",
      url: "https://rafaelg.net.br/dissertacao.pdf",
      title:
        "<em>Mediação algorítmica e aprendizado de máquina: uma caracterização baseada em patentes da Google sobre técnicas de modulação de atividade</em>",
      complement: "Dissertação (mestrado), Campinas: Universidade Estadual de Campinas, 2025.",
    },
    {
      authors: "Ferreira, Pedro Peixoto; GONÇALVES, Rafael",
      url: "https://periodicos.ufba.br/index.php/crh/article/view/62006",
      title:
        "Padrões depressivos: fenotipagem digital e subjetivação neoliberal",
      complement: "<em>Cadernos CRH</em>, v. 37, e024041 , 2025.",
    },
    {
      authors: "GONÇALVES, Rafael",
      url: "https://www.esocite2024.com.br/anais.pdf",
      title:
        "Mediação algorítmica, viés de gênero e sexismo algorítmico",
      complement: "<em>Anais da XV Jornada Latino-Americana de Estudos Sociais da Ciência e Tecnologia (Esocite LA)</em>, Campinas, 2024.",
    },
    {
      authors: "GONÇALVES, Rafael; Padovan, Giordanno Oliveira",
      url: "https://anais.rba.abant.org.br/34rba/trabalho?trabalho=22896221",
      title:
        "Captura da virtualidade em algoritmos bioinspirados: apropriação da informação em práticas de modelagem computacional biomimética",
      complement: "<em>Anais da 34ª Reunião Brasileira de Antropologia (RBA)</em>, Belo Horizonte, 2024.",
    },
    {
      authors: "GONÇALVES, Rafael",
      url: "https://doi.org/10.20396/ideias.v13i00.8668218",
      title:
        "Automatismo ontem e hoje: reflexões sobre os limites da inteligência artificial a partir de Simondon",
      complement: "<em>Ideias</em>, v. 13, e022008, 2022.",
    },
  ];

  return (
    <>
      <Helmet title="Sobre" />
      <Layout isReadingPage header="Sobre" className={styles.wrapper}>
        <div className={styles.content}>
          <section className={styles.about}>
            <Image
              srcInfo={srcInfo}
              className={styles.image}
              gatsbyImgProps={{ fluid: data.fileName.childImageSharp.fluid }}
            />
            <div className={styles.body}>
              <p>
                Criei esta página com a intenção de reunir meus estudos recentes em ciências sociais e, em particular, sociologia da tecnologia. É, assim, local de registro e experimentação de meu processo pessoal de pesquisa. Meus interesses também incluem: teoria crítica em seu sentido amplo; filosofia, sociologia e antropologia contemporâneas e estudos sociais da ciência e da tecnologia. Autores que me interessam em específico são Gilles Deleuze, Félix Guattari e{" "}
                <a
                  href="https://gregsifch.wordpress.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Gilbert Simondon
                </a>
                .
              </p>
              <p>
                Atualmente, sou doutorando em ciências sociais pelo IFCH/Unicamp, com
                pesquisa sobre descolonização e tecnologias digitais, e
                participo do{" "}
                <a
                  href="https://www.laspa.slg.br/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Laboratório da Sociologia dos Processos de Associação (LaSPA)
                </a>
                . Concluí recentemente um mestrado em sociologia pelo IFCH/Unicamp
                com pesquisa sobre a modulação de comportamento operado por
                técnicas de aprendizado de máquina a partir da análise de
                patentes da Google. Possuo graduação em engenharia elétrica pela
                FEEC/Unicamp, onde pude estudar a área de aprendizado de
                máquina, tendo me dedicado em especial às redes neurais
                artificiais e ao aprendizado profundo.
              </p>
            </div>
          </section>
          <section className={styles.publications}>
            <header>
              <h2>Principais produções</h2>
            </header>
            <ul>
              {productionList.map(({ authors, title, complement, url }, i) => (
                <li key={i}>
                  {authors}{". "}
                  {url ? (
                    <a href={url} target="_blank" rel="noreferrer noopener">
                      <span dangerouslySetInnerHTML={{ __html: title }} />
                    </a>
                  ) : (
                    <span dangerouslySetInnerHTML={{ __html: title }} />
                  )}{". "}
                  <span dangerouslySetInnerHTML={{ __html: complement }} />
                </li>
              ))}
            </ul>
          </section>
        </div>
      </Layout>
    </>
  );
};

export default About;
